module.exports = __webpack_public_path__ + "img/c010_1.36aabf70.jpg";